/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Hardcoded horizontal timeline of Manhattan WMS versions Lalit has
 * implemented in production. Not data-driven — these seven anchor
 * points are the spine of the 22-year practitioner story.
 */

import React from 'react';

const VERSIONS = [
  { year: 2001, name: 'PkMS 2001 R1' },
  { year: 2004, name: 'PkMS 2004 R2' },
  { year: 2006, name: 'PkMS 2006 R0' },
  { year: 2017, name: 'WMi 2017' },
  { year: 2018, name: 'WMi 2018' },
  { year: 2022, name: 'WMi 2022' },
  { year: 2025, name: 'WMi 2025', isLatest: true },
];

const VersionTimeline = () => (
  <div className="mt-14">
    <p className="text-center text-sm italic text-brand-muted2 mb-6">
      Versions Lalit has implemented in production environments
    </p>

    <div className="overflow-x-auto pb-2">
      <div className="flex items-start min-w-max">
        {VERSIONS.map((v, i) => (
          <React.Fragment key={v.year}>
            <div className="flex flex-col items-center text-center w-[140px] shrink-0">
              <div
                className={
                  v.isLatest
                    ? 'w-14 h-14 rounded-full flex items-center justify-center font-bold text-base bg-gradient-to-br from-brand-cyanLight to-brand-blue text-white ring-4 ring-brand-cyan/30 shadow-brand'
                    : 'w-14 h-14 rounded-full flex items-center justify-center font-bold text-base bg-white border-2 border-brand-cyan text-brand-cyanDark'
                }
              >
                {v.year}
              </div>
              <p
                className={
                  v.isLatest
                    ? 'mt-3 font-bold text-sm text-brand-cyanDark'
                    : 'mt-3 font-bold text-sm text-brand-text'
                }
              >
                {v.name}
              </p>
            </div>
            {i < VERSIONS.length - 1 && (
              <div
                aria-hidden="true"
                className="h-0.5 bg-brand-borderAccent mt-7 w-8 sm:w-10 shrink-0"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
);

export default VersionTimeline;
